import { Reveal, SectionHeader } from "./Reveal";
import PhotoFrame from "./PhotoFrame";
import canecaImg from "../assets/photos/caneca.jpg";
import cestaVerdeImg from "../assets/photos/cesta-verde.jpg";
import cestaAzulImg from "../assets/photos/cesta-azul.jpg";
import azulejoImg from "../assets/photos/azulejo.jpg";
import chaveiroImg from "../assets/photos/chaveiro.jpg";
import kitImg from "../assets/photos/kit.jpg";
import memorialImg from "../assets/photos/memorial.jpg";
import cestaZagoImg from "../assets/photos/cesta-zago.jpg";

const ITEMS = [
    { img: canecaImg, span: "col-span-2 row-span-2 aspect-square" },
    { img: cestaVerdeImg, span: "aspect-[4/3]" },
    { img: cestaAzulImg, span: "aspect-[4/3]" },
    { img: azulejoImg, span: "aspect-[4/3]" },
    { img: chaveiroImg, span: "aspect-[4/3]" },
    { img: kitImg, span: "col-span-2 aspect-[8/5]" },
    { img: memorialImg, span: "aspect-[4/3]" },
    { img: cestaZagoImg, span: "aspect-[4/3]" },
];

export default function Gallery() {
    return (
        <section id="galeria" className="bg-paper py-20 sm:py-28 lg:py-32">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeader
                    eyebrow="Galeria"
                    title={
                        <>
                            Nossos <span className="italic text-gold-deep">trabalhos</span>
                        </>
                    }
                />

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 mt-14 lg:mt-20 auto-rows-auto">
                    {ITEMS.map((item, i) => (
                        <Reveal
                            key={i}
                            delay={0.05 * i}
                            testId={`gallery-item-${i + 1}`}
                            className={item.span}
                        >
                            <PhotoFrame
                                img={item.img}
                                label={item.label}
                                ratio="h-full w-full"
                                testId={`gallery-frame-${i + 1}`}
                                caption="Foto real em breve"
                            />
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.15} className="text-center mt-10">
                    <p className="font-body text-sm text-inksoft">
                        Fotos reais dos nossos produtos — novos trabalhos
                        adicionados sempre.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
